import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { getPromptPreview, SchemaQueryKeys, type PromptPreviewResponse } from '../api';

interface UsePromptPreviewOptions {
  /** When false, the query stays paused — used to defer the fetch until the modal opens. */
  enabled?: boolean;
}

/**
 * Renders the compiled prompt for `slug`, optionally overriding the sample OCR text.
 * The cache key includes the `sampleText` so different sample inputs don't collide.
 */
export function usePromptPreview(
  slug: string | undefined,
  sampleText: string | undefined,
  options: UsePromptPreviewOptions = {},
): UseQueryResult<PromptPreviewResponse> {
  const { enabled = true } = options;
  return useQuery({
    queryKey: SchemaQueryKeys.promptPreview(slug ?? '', sampleText),
    queryFn: ({ signal }) => getPromptPreview(slug as string, sampleText, signal),
    enabled: enabled && slug !== undefined && slug !== '',
    staleTime: 0,
  });
}
